/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from 'moment-timezone';
import React from 'react';
import DatePicker from 'react-date-picker';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import isEmail from 'validator/lib/isEmail';

import tagManager from '../../app/services/tagManager';
import {
  cartSetClientNumber, cartSetDeliverySector, cartSetMinimumBillingDate,
  cartSetResponsibleReceiving,
  cartSolicitation, getFreightGKO,
  setObservation, cartSetManagerEmail,
} from '../../app/store/actions/cart';
import { estimatePurchase, savePurchaseFeedback } from '../../app/store/actions/purchases';
import CartUtil from '../../app/utils/cart';
import InputSize from '../../data/inputs';
import ROUTES from '../../data/routes';
import validator from '../../helpers/validators';
import { history } from '../../routers/AppRouter';
import PriceComponent from '../price/Price';
import PurchaseFeedback from '../purchaseFeedback/purchaseFeedback';
import { updatePunchOutData } from '../../app/store/actions/punchOut';

const RctSwal = withReactContent(Swal);
class CartResume extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      clientNumber: props.clientNumber,
      minimumBillingDate: props.minimumBillingDate,
      isValidMinimumBillingDate: false,
      feedbackModal: false,
      isValidManagerEmail: true,
      managerEmail: props.managerEmail,
      punchoutUserIndicator: {
        parameters: {
          email: '',
          name: '',
          phone: '',
          unit: '',
        },
        errors: {
          hasError: false,
          message: '',
        },
      },
      isValiDeliveryAddress: true,
      isValidResponsibleReceiving: true,
      isValidDeliverySector: true,
      messageOfErrorSolicitation: '',
      messageOfErrorEstimate: '',
    };
  }

  componentDidMount = () => {
    const valid = (
      this.props.cartItems
      && this.props.cartItems.length
      && this.props.cartItems[0].product
      && this.props.cartItems[0].product.observation
    );

    if (valid) this.props.setObservation(this.props.cartItems[0].product.observation);

    this.props.getFreightGKO();
  }

  validationMaximumContractValue = () => {
    const valueContract = [];
    const contractId = [];

    for (let index = 0; index < this.props.cartItems.length; index += 1) {
      if (this.props.cartItems[index].product && this.props.cartItems[index].product.valueContract) {
        valueContract.push(this.props.cartItems[index].product.valueContract);
        contractId.push(this.props.cartItems[index].product.contractId);
      }
    }

    const valueContractErro = this.props.cartItems.findIndex(element => (
      element.product.erro === true || element.product.erro === 'true'));

    let contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 1));
    if (!contractLimitAction) {
      contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 2));
    }

    contractLimitAction = (contractLimitAction
      && contractLimitAction.product
      && contractLimitAction.product.contractLimitAction)
      ? contractLimitAction.product.contractLimitAction
      : '';

    return {
      contractLimitAction, valueContract, contractId, valueContractErro,
    };
  }

  validationMaximumContractValue = () => {
    const valueContract = [];
    const contractId = [];

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < this.props.cartItems.length; index++) {
      if (this.props.cartItems[index].product && this.props.cartItems[index].product.valueContract) {
        valueContract.push(this.props.cartItems[index].product.valueContract);
        contractId.push(this.props.cartItems[index].product.contractId);
      }
    }

    const valueContractErro = this.props.cartItems.findIndex(element => (
      element.product.erro === true || element.product.erro === 'true'));

    let contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 1));
    if (!contractLimitAction) contractLimitAction = this.props.cartItems.find(element => (element.product.contractLimitAction === 2));

    contractLimitAction = (contractLimitAction
      && contractLimitAction.product
      && contractLimitAction.product.contractLimitAction)
      ? contractLimitAction.product.contractLimitAction
      : '';

    return {
      contractLimitAction, valueContract, contractId, valueContractErro,
    };
  }

  setClientNumber = async (e) => {
    await this.setState({ clientNumber: e.target.value });
  };

  setMinimumBillingDate = async (date) => {
    await this.props.setMinimumBillingDate(date);

    if (!date) {
      await this.setState({ minimumBillingDate: null });
    } else if ((date instanceof Date) && (!isNaN(date)) && (moment(date, 'DD/MM/YYYY').isValid())) {
      await this.setState({
        minimumBillingDate: date,
        isValidMinimumBillingDate: true,
      });
    } else {
      await this.setState({ minimumBillingDate: null });
    }
  }

  sentSolicitation = async () => {
    const {
      deliveryAddressType, internalDeliveryAddress, responsibleReceiving, deliverySector, punchOut, typeOfAccess,
      userEmail,
    } = this.props;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      if (deliveryAddressType) {
        await this.setState({ isValiDeliveryAddress: true });

        const { deliveryAddress } = this.props;

        if (!Object.keys(deliveryAddress).length) {
          await this.setState({ isValiDeliveryAddress: false });
          return null;
        }
      }

      if (internalDeliveryAddress) {
        await this.setState({ isValidResponsibleReceiving: true, isValidDeliverySector: true });

        if (!responsibleReceiving) {
          await this.setState({ isValidResponsibleReceiving: false });
          return null;
        }

        if (!deliverySector) {
          await this.setState({ isValidDeliverySector: false });
          return null;
        }
      }

      try {
        await this.props.cartSolicitation();
        await this.props.setView('solicitation');

        tagManager.ecommerceCheckoutSteps(
          (this.props.cartItems || []).map(it => it.product || {}), 1, 'CartSolicitation',
        );

        await this.setState({ messageOfErrorSolicitation: '' });
      } catch (error) {
        const validError = !!(error.response && error.response.data && error.response.data.error);

        if (validError && error.response.data.error.code === 1614) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else if (validError && error.response.data.error.code === 1615) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else {
          const details = validError && error.response.data.error.details;

          await this.setState({
            messageOfErrorSolicitation: I18n.t('errorTryLater') + (details ? ` (${details})` : ''),
          });
        }
      }
    }
  };

  estimateSolicitation = async () => {
    const { punchOut, typeOfAccess, userEmail } = this.props;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      try {
        await this.props.estimatePurchase();
        await this.props.setView('estimate');

        tagManager.ecommerceCheckoutSteps((this.props.cartItems || []).map(it => it.product || {}), 1, 'CartEstimate');

        await this.setState({ messageOfErrorEstimate: '' });
      } catch (error) {
        const validError = !!(error.response && error.response.data && error.response.data.error);

        if (validError && error.response.data.error.code === 1614) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else if (validError && error.response.data.error.code === 1615) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else {
          const details = validError && error.response.data.error.details;

          await this.setState({
            messageOfErrorEstimate: I18n.t('errorTryLater') + (details ? ` (${details})` : ''),
          });
        }
      }
    }
  };

  getObservationByCompany = (empName) => {
    switch (empName) {
      case 'nortel':
        return I18n.t('observationTextNortel');
      default:
        return I18n.t('observationText');
    }
  }

  getObservationMinMax = (empName) => {
    switch (empName) {
      case 'nortel':
        return InputSize.observationNortel;
      default:
        return InputSize.observation;
    }
  }

  goToCheckout = async () => {
    const {
      minimumBillingDate, managerEmailPermission, userEmail, managerEmail, cartItems, punchOut, typeOfAccess,
    } = this.props;

    const { clientNumber } = this.state;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      if (clientNumber === '') await this.props.setClientNumber(null);
      else await this.props.setClientNumber(clientNumber);

      if (minimumBillingDate !== null && !moment(minimumBillingDate, 'DD/MM/YYYY').isValid()) {
        await this.setState({ isValidMinimumBillingDate: false });
        return null;
      }

      if (managerEmailPermission) {
        if (!managerEmail || (managerEmail && !isEmail(managerEmail)) || (managerEmail === userEmail)) {
          await this.setState({ isValidManagerEmail: false });
          return null;
        }

        await this.setState({ isValidManagerEmail: true });
      }

      if (cartItems.length > 0) {
        const products = [];
        for (let index = 0; index < cartItems.length; index += 1) {
          const element = cartItems[index];

          if ((Object.keys(element.product).length > 0) && element.product.quantity && element.product.multipleQuantity) {
            if ((element.product.quantity % parseFloat(element.product.multipleQuantity)) !== 0) {
              products.push(element.product.id);
            }
          }
        }

        if (products.length > 0) {
          this.multipleValidation(products.toString().replace(',', ', '));
          return null;
        }
      }

      history.push(ROUTES.CHECKOUT);
    }
  };

  setObservation = (value) => {
    const { isLocker, observation, deliveryAddress } = this.props;
    const { address } = deliveryAddress;

    if ((isLocker || (address && address.isLocker)) && (value.indexOf('Cliente Retira no LOCKER - ') < 0)) {
      if (observation.indexOf('Cliente Retira no LOCKER - ') < 0) {
        this.props.setObservation(`Cliente Retira no LOCKER - ${value}`);
      }
    } else {
      this.props.setObservation(value);
    }
  };

  multipleValidation = productsCodes => (
    Swal.fire({
      titleText: I18n.t('ProductsInCartWithInvalidMultipleQuantities'),
      text: productsCodes,
      icon: 'warning',
    })
  );

  renderButton = (company, observation, inputObs) => {
    const {
      cartItems, taxesCart, selectedContract, purchasePermission, minimumPrice, buttonLabel,
      allowSellSpotItensWithoutStock, companyTag, isCheckout, minimumBillingDate,
    } = this.props;

    const {
      isValidMinimumBillingDate, isValidManagerEmail, isValiDeliveryAddress, isValidResponsibleReceiving,
      isValidDeliverySector,
    } = this.state;

    const { limit } = selectedContract;

    const cartTotal = CartUtil.getCartTotal(cartItems, !taxesCart, undefined, undefined, companyTag);

    const hasItemWithoutStock = cartItems.filter(item => validator.isSpotProductAmountInvalid(
      item.total, item.product.stock, allowSellSpotItensWithoutStock, item.product.isSpot,
      item.product.price.isContract,
    ));

    const {
      contractLimitAction, valueContract, contractId, valueContractErro,
    } = this.validationMaximumContractValue();

    if (hasItemWithoutStock && hasItemWithoutStock.length > 0) {
      return (
        <p className="error-msg">
          {I18n.t('invalidItemsCart')}
        </p>
      );
    }

    if ((limit && cartTotal > Number(limit)) || !purchasePermission) {
      return (
        <React.Fragment>
          <label className="lbl">
            {this.getObservationByCompany(company)}
            <textarea
              className="txt"
              rows={4}
              value={observation}
              onChange={text => this.setObservation(text.target.value)}
              minLength={inputObs.min}
              maxLength={inputObs.max}
            />
          </label>
          {!isCheckout && (
            <button
              className="btn"
              type="button"
              onClick={() => this.sentSolicitation()}
            >
              {I18n.t('buySolicitation')}
            </button>
          )}
          {!isCheckout && !isValiDeliveryAddress && (
            <p className="error-msg">
              {I18n.t('requiredDeliveryAddress')}
            </p>
          )}
          {!isCheckout && !isValidResponsibleReceiving && (
            <p className="error-msg">
              {I18n.t('invalidResponsibleReceiving')}
            </p>
          )}
          {!isCheckout && !isValidDeliverySector && (
            <p className="error-msg">
              {I18n.t('invalidDeliverySector')}
            </p>
          )}
        </React.Fragment>
      );
    }

    if (purchasePermission) {
      if (minimumPrice <= CartUtil.getCartTotal(cartItems, !taxesCart, undefined, undefined, companyTag)
        && contractLimitAction !== 1
        && valueContractErro < 0) {
        return (
          <React.Fragment>
            <label className="lbl">
              {this.getObservationByCompany(company)}
              <textarea
                className="txt"
                rows={4}
                value={observation}
                onChange={text => this.setObservation(text.target.value)}
                minLength={inputObs.min}
                maxLength={inputObs.max}
              />
            </label>
            {!isCheckout && (
              <button
                className="btn"
                type="button"
                onClick={() => this.goToCheckout()}
              >
                {buttonLabel || I18n.t('finalizeBuy')}
              </button>
            )}
            {!isCheckout && !isValidMinimumBillingDate && minimumBillingDate !== null && (
              <p className="error-msg">
                {I18n.t('invalidMinimumBillingDate')}
              </p>
            )}
            {!isCheckout && !isValidManagerEmail && (
              <p className="error-msg">
                {I18n.t('invalidManagerEmail')}
              </p>
            )}
            {!isCheckout && contractLimitAction === 2 && (
              <p className="error-msg">
                {(contractId.length > 1)
                  ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                  : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                }
                {valueContract.map(element => (
                  <span>
                    {' '}
                    <PriceComponent value={element} />
                  </span>
                ))}
                {(contractId.length > 1)
                  ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                  : ` ${I18n.t('noticeMaximumContractValue3')}`
                }
              </p>
            )}
          </React.Fragment>
        );
      }

      return (
        <div>
          {(contractLimitAction === 1 || valueContractErro >= 0) ? (
            <div>
              {(valueContractErro < 0)
                ? (
                  <p className="error-msg">
                    {(contractId.length > 1)
                      ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                      : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                    }
                    {valueContract.map(element => (
                      <span>
                        {' '}
                        <PriceComponent value={element} />
                      </span>
                    ))}
                    {(contractId.length > 1)
                      ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                      : ` ${I18n.t('noticeMaximumContractValue3')}`
                    }
                  </p>
                )
                : (
                  <p className="error-msg">
                    {I18n.t('erroMaximumContractValue')}
                  </p>
                )
              }
            </div>
          )
            : (
              <p className="error-msg">
                {I18n.t('minimumOf')}
                {' '}
                {<PriceComponent value={minimumPrice} />}
                {' '}
                {I18n.t('toBuy')}
              </p>
            )
          }
        </div>
      );
    }
  };

  renderClientOrder = (clientNumber, isCheckout = false) => {
    if (isCheckout) {
      if (clientNumber) {
        return (
          <label className="lbl">
            <span style={{ fontWeight: 600 }}>{I18n.t('orderCodeOptional')}</span>
            <p style={{ marginTop: 6, marginBottom: 32 }}>{clientNumber}</p>
          </label>
        );
      }

      return null;
    }

    return (
      <label className="lbl">
        {I18n.t('orderCodeOptional')}
        <input
          type="text"
          maxLength={InputSize.clientOrderNumber}
          className="fld"
          value={clientNumber || ''}
          onChange={this.setClientNumber}
        />
      </label>
    );
  }

  renderBillingDate = (minimumBillingDate, isCheckout = false) => {
    if (isCheckout) {
      if (minimumBillingDate) {
        return (
          <label className="lbl">
            <span style={{ fontWeight: 600 }}>{I18n.t('minimumBillingDate')}</span>
            <span className="billingTooltip" title={I18n.t('billingDateTooltip')}> (?)</span>
            <p style={{ marginTop: 6, marginBottom: 32 }}>{moment(minimumBillingDate).format('DD/MM/YYYY')}</p>
          </label>
        );
      }

      return null;
    }

    let labelDesc = I18n.t('billingDateInformation');

    if (this.props.purchaseCreditMinDeliveryDatePermission) labelDesc += `, ${I18n.t('credit').toUpperCase()}`;
    if (this.props.purchaseBankSlipMinDeliveryDatePermission) labelDesc += `, ${I18n.t('bankSlip').toUpperCase()}`;

    return (
      <label className="lbl">
        {I18n.t('minimumBillingDate')}

        <span id="billingTooltip" title={I18n.t('billingDateTooltip')}> (?)</span>

        <DatePicker
          className="fld billingDatePicker"
          value={minimumBillingDate}
          onChange={date => this.setMinimumBillingDate(date)}
          minDate={new Date()}
          dateFormat="dd/MM/yyyy"
          fixedHeight
          isClearable
        />

        <span style={{ color: 'red' }}>{labelDesc}</span>
      </label>
    );
  }


  renderPurchaseFeedback = async () => {
    const { punchOut, typeOfAccess, userEmail } = this.props;

    const {
      punchoutUserIndicatorParameters, punchoutUserIndicatorEmail, punchoutUserIndicatorName,
      punchoutUserIndicatorPhone, punchoutUserIndicatorUnit,
    } = this.props.selectedContract.clientDetails;

    const { parameters } = this.state.punchoutUserIndicator;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      await this.setState({
        punchoutUserIndicator: {
          parameters: { ...parameters },
          errors: {
            hasError: false,
            message: '',
          },
        },
      });

      if (punchoutUserIndicatorParameters) {
        if (punchoutUserIndicatorEmail && !parameters.email) {
          await this.setState({
            punchoutUserIndicator: {
              parameters: { ...parameters },
              errors: {
                hasError: true,
                message: I18n.t('requiredEmail'),
              },
            },
          });
        } else if (punchoutUserIndicatorName && !parameters.name) {
          await this.setState({
            punchoutUserIndicator: {
              parameters: { ...parameters },
              errors: {
                hasError: true,
                message: I18n.t('requiredName'),
              },
            },
          });
        } else if (punchoutUserIndicatorPhone && !parameters.phone) {
          await this.setState({
            punchoutUserIndicator: {
              parameters: { ...parameters },
              errors: {
                hasError: true,
                message: I18n.t('requiredPhone'),
              },
            },
          });
        } else if (punchoutUserIndicatorUnit && !parameters.unit) {
          await this.setState({
            punchoutUserIndicator: {
              parameters: { ...parameters },
              errors: {
                hasError: true,
                message: I18n.t('requiredUnit'),
              },
            },
          });
        } else {
          await this.props.setPunchOutData({
            punchoutUserIndicator: {
              email: parameters.email || null,
              name: parameters.name || null,
              phone: parameters.phone || null,
              unit: parameters.unit || null,
            },
          });

          await this.setState({ feedbackModal: true });
        }
      } else {
        await this.setState({ feedbackModal: true });
      }
    }
  }

  closeFeedbackModal = async (feedbackData) => {
    await this.props.setFeedback(feedbackData || null);
    await this.setState({ feedbackModal: false });
    history.push(ROUTES.PUNCH_OUT_CHECKOUT, { isPushPunchout: true });
  }

  setPunchoutUserIdentificationForm = async (dataValue, dataLabel) => {
    const { punchoutUserIndicator } = this.state;

    await this.setState({
      punchoutUserIndicator: {
        ...punchoutUserIndicator,
        parameters: {
          ...punchoutUserIndicator.parameters,
          [`${dataLabel}`]: dataValue,
        },
      },
    });
  }

  renderPunchoutUserIdentification = (selectedContract) => {
    const {
      email,
      name,
      phone,
      unit,
    } = this.state.punchoutUserIndicator.parameters;

    if (selectedContract.clientDetails) {
      if (selectedContract.clientDetails.punchoutUserIndicatorParameters) {
        return (
          <React.Fragment>
            <label className="lbl">
              {selectedContract.clientDetails.punchoutUserIndicatorEmail
                ? `${I18n.t('email')}: (${I18n.t('requiredField')})`
                : `${I18n.t('email')}`}
              <input
                type="text"
                className="fld"
                required={!!selectedContract.clientDetails.punchoutUserIndicatorEmail}
                value={email}
                onChange={event => this.setPunchoutUserIdentificationForm(event.target.value, 'email')}
              />
            </label>
            <label className="lbl">
              {selectedContract.clientDetails.punchoutUserIndicatorName
                ? `${I18n.t('name')}: (${I18n.t('requiredField')})`
                : `${I18n.t('name')}`}
              <input
                type="text"
                className="fld"
                required={!!selectedContract.clientDetails.punchoutUserIndicatorName}
                maxLength={InputSize.name}
                value={name}
                onChange={event => this.setPunchoutUserIdentificationForm(event.target.value, 'name')}
              />
            </label>
            <label className="lbl">
              {selectedContract.clientDetails.punchoutUserIndicatorPhone
                ? `${I18n.t('phone2')}: (${I18n.t('requiredField')})`
                : `${I18n.t('phone2')}`}
              <InputMask
                className="fld"
                required={!!selectedContract.clientDetails.punchoutUserIndicatorPhone}
                mask={
                  phone && phone.length > 14
                    ? '(99) 99999-9999'
                    : '(99) 9999-99999'
                }
                maskChar={null}
                value={phone}
                onChange={event => this.setPunchoutUserIdentificationForm(event.target.value, 'phone')}
              />
            </label>
            <label className="lbl">
              {selectedContract.clientDetails.punchoutUserIndicatorUnit
                ? `${I18n.t('unit')}: (${I18n.t('requiredField')})`
                : `${I18n.t('unit')}`}
              <input
                type="text"
                className="fld"
                required={!!selectedContract.clientDetails.punchoutUserIndicatorUnit}
                value={unit}
                onChange={event => this.setPunchoutUserIdentificationForm(event.target.value, 'unit')}
              />
            </label>
          </React.Fragment>
        );
      }
    }

    return null;
  }

  renderManagerEmailIdentification = (managerEmail, isCheckout = false) => {
    const { managerEmailPermission } = this.props;

    if (isCheckout) {
      if (managerEmailPermission) {
        return (
          <label className="lbl">
            <span style={{ fontWeight: 600 }}>{`${I18n.t('managerEmail')}: (${I18n.t('requiredField')})`}</span>
            <p style={{ marginTop: 6, marginBottom: 32 }}>{managerEmail}</p>
          </label>
        );
      }

      return null;
    }

    return (
      <label className="lbl">
        {`${I18n.t('managerEmail')}: (${I18n.t('requiredField')})`}
        <input
          type="text"
          className="fld"
          required
          value={managerEmail}
          onChange={event => this.setManagerEmail(event.target.value)}
        />
      </label>
    );
  }

  setManagerEmail = async (managerEmail) => {
    await this.props.setManagerEmail(managerEmail);
    await this.setState({ managerEmail });
  }

  renderInternalDeliverAddressIdentification = (responsibleReceiving, deliverySector, isCheckout = false) => {
    if (isCheckout) {
      if (responsibleReceiving && deliverySector) {
        return (
          <React.Fragment>
            <label className="lbl">
              <span style={{ fontWeight: 600 }}>{I18n.t('responsibleForReceiving')}</span>
              <p style={{ marginTop: 6, marginBottom: 32 }}>{responsibleReceiving}</p>
            </label>
            <label className="lbl">
              <span style={{ fontWeight: 600 }}>{I18n.t('deliverySector')}</span>
              <p style={{ marginTop: 6, marginBottom: 32 }}>{deliverySector}</p>
            </label>
          </React.Fragment>
        );
      }

      return null;
    }

    return (
      <React.Fragment>
        <label className="lbl">
          {I18n.t('responsibleForReceiving')}
          <input
            type="text"
            className="fld"
            value={responsibleReceiving || ''}
            onChange={event => this.props.setResponsibleReceiving(event.target.value)}
          />
        </label>
        <label className="lbl">
          {I18n.t('deliverySector')}
          <input
            type="text"
            className="fld"
            value={deliverySector || ''}
            onChange={event => this.props.setDeliverySector(event.target.value)}
          />
        </label>
      </React.Fragment>
    );
  }

  render() {
    const {
      subTotal = 0, discount = 0, hasItems, pricePermission, purchasePermission, clientCodePermission,
      purchaseEstimatePermission, observation, companyTag, st, taxName = 'ST', taxesCart, punchOut, isCheckout,
      selectedContract, gkoFreightOptions, managerEmailPermission, internalDeliveryAddress, responsibleReceiving,
      deliverySector, cartUser,
    } = this.props;

    const {
      clientNumber, minimumBillingDate, feedbackModal, punchoutUserIndicator, managerEmail, messageOfErrorSolicitation,
      messageOfErrorEstimate,
    } = this.state;

    const {
      contractLimitAction, valueContract, contractId, valueContractErro,
    } = this.validationMaximumContractValue();

    const company = companyTag || '';
    const inputObs = this.getObservationMinMax(company);

    let valueTotal = subTotal - discount;
    if (taxesCart) valueTotal += st;

    return (
      <div className="box-aside">
        {pricePermission && (
          <ul className="resume" style={{ marginBottom: '0px' }}>
            <li>
              <span><strong>{I18n.t('summary')}</strong></span>
            </li>
            {cartUser && (
              <React.Fragment>
                <li>
                  <span>{I18n.t('requestUserName')}</span>
                  <span style={{ wordBreak: 'break-word' }}>{cartUser.name}</span>
                </li>
                <li>
                  <span>{I18n.t('requestUserEmail')}</span>
                  <span style={{ wordBreak: 'break-word' }}>{cartUser.email}</span>
                </li>
              </React.Fragment>
            )}
            <li className="border" style={{ padding: '0px' }} />
            <li>
              <span>{I18n.t('subTotal')}</span>
              <span><PriceComponent value={subTotal} /></span>
            </li>
            <li>
              <span>{I18n.t('discount')}</span>
              <span>{<PriceComponent value={discount} /> || '-'}</span>
            </li>
            {taxesCart && (
              <li className="border">
                <span>{taxName}</span>
                <span>{<PriceComponent value={st} /> || 'R$ 0,00'}</span>
              </li>
            )}
            <li className="border" style={{ marginBottom: '30px' }}>
              <span><strong>{I18n.t('total')}</strong></span>
              <span><strong><PriceComponent value={valueTotal} /></strong></span>
            </li>
            {!punchOut && (gkoFreightOptions && gkoFreightOptions.length > 0) && (
              <li style={{ justifyContent: 'center', textAlign: 'center' }}>
                <span>
                  Receba em até
                  {' '}
                  {gkoFreightOptions[0].deadLine}
                  {' '}
                  dia(s) úteis após a confirmação do pagamento
                </span>
              </li>
            )}
          </ul>
        )}
        {hasItems && (
          <div className="additional" style={{ marginTop: '0px' }}>
            {!punchOut
              && purchasePermission
              && selectedContract.purchaseBillingPermission
              && this.renderBillingDate(minimumBillingDate, isCheckout)
            }
            {!punchOut
              && clientCodePermission
              && purchasePermission
              && this.renderClientOrder(clientNumber, isCheckout)
            }
            {!!punchOut
              && !isCheckout
              && (contractLimitAction !== 1)
              && (valueContractErro < 0)
              && this.renderPunchoutUserIdentification(selectedContract)
            }
            {!punchOut
              && purchasePermission
              && managerEmailPermission
              && this.renderManagerEmailIdentification(managerEmail, isCheckout)
            }
            {!punchOut
              && !purchasePermission
              && internalDeliveryAddress
              && this.renderInternalDeliverAddressIdentification(responsibleReceiving, deliverySector, isCheckout)
            }
            {!punchOut && this.renderButton(company, observation, inputObs)}
            {!punchOut && purchaseEstimatePermission && !isCheckout && (
              <button
                type="button"
                className="btn"
                onClick={() => this.estimateSolicitation()}
              >
                {I18n.t('estimateSolicitation')}
              </button>
            )}
            {!!punchOut && !isCheckout && (contractLimitAction !== 1) && (valueContractErro < 0) && (
              <div>
                <button
                  className="btn"
                  type="button"
                  onClick={() => this.renderPurchaseFeedback()}
                >
                  {I18n.t('buyPunchOut')}
                </button>
                {contractLimitAction === 2 && (
                  <p className="error-msg">
                    {(contractId.length > 1)
                      ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                      : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                    }
                    {valueContract.map(element => (
                      <span>
                        {' '}
                        <PriceComponent value={element} />
                      </span>
                    ))}
                    {(contractId.length > 1)
                      ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                      : ` ${I18n.t('noticeMaximumContractValue3')}`
                    }
                  </p>
                )}
                {punchoutUserIndicator.errors.hasError && (
                  <p className="error-msg">
                    {punchoutUserIndicator.errors.message}
                  </p>
                )}
              </div>
            )}
            {!!punchOut && !isCheckout && (contractLimitAction === 1 || valueContractErro >= 0) && (
              <div>
                {(valueContractErro < 0)
                  ? (
                    <p className="error-msg">
                      {(contractId.length > 1)
                        ? `${I18n.t('noticeMaximumValueContracts1')} ${contractId} ${I18n.t('noticeMaximumValueContracts2')} `
                        : `${I18n.t('noticeMaximumContractValue1')} ${contractId} ${I18n.t('noticeMaximumContractValue2')} `
                      }
                      {valueContract.map(element => (
                        <span>
                          {' '}
                          <PriceComponent value={element} />
                        </span>
                      ))}
                      {(contractId.length > 1)
                        ? ` ${I18n.t('noticeMaximumValueContracts3')}`
                        : ` ${I18n.t('noticeMaximumContractValue3')}`
                      }
                    </p>
                  )
                  : (
                    <p className="error-msg">
                      {I18n.t('erroMaximumContractValue')}
                    </p>
                  )
                }
              </div>
            )}
            {messageOfErrorSolicitation && (
              <p className="error-msg">
                {messageOfErrorSolicitation}
              </p>
            )}
            {messageOfErrorEstimate && (
              <p className="error-msg">
                {messageOfErrorEstimate}
              </p>
            )}
            {hasItems && !!punchOut && feedbackModal && (
              <PurchaseFeedback closePurchaseFeedback={feedbackData => this.closeFeedbackModal(feedbackData)} />
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  punchOut: state.punchOut,
  companyTag: state.settings && state.settings.companyTag,
  taxesCart: state.settings && !state.settings.taxsCartOff,
  taxName: state.settings && state.settings.taxName,
  contracts: state.contracts,
  selectedContract: state.contracts.selected,
  purchasePermission: state.contracts.selected && state.contracts.selected.purchasePermission,
  purchaseCreditMinDeliveryDatePermission: state.contracts.selected
    && state.contracts.selected.purchaseCreditMinDeliveryDatePermission,
  purchaseBankSlipMinDeliveryDatePermission: state.contracts.selected
    && state.contracts.selected.purchaseBankSlipMinDeliveryDatePermission,
  purchaseEstimatePermission: state.contracts.selected && state.contracts.selected.purchaseEstimatePermission,
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  clientCodePermission: state.contracts.selected && state.contracts.selected.clientCodePermission,
  buttonLabel: state.contracts.selected && state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.buyButtonLabel,
  minimumPrice: state.contracts.selected && state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.minimumPurchase > 0
    ? Number(state.contracts.selected.clientDetails.minimumPurchase)
    : Number(state.settings.minimumPurchase),
  allowSellSpotItensWithoutStock: state.contracts.selected && state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
  clientNumber: state.cart.clientNumber,
  minimumBillingDate: state.cart.minimumBillingDate,
  cartItems: state.cart.items,
  observation: state.cart.observation,
  gkoFreightOptions: state.cart.freightGKO,
  purchaseFeedback: state.purchase && state.purchase.purchaseFeedback,
  userEmail: state.auth && state.auth.user && state.auth.user.email,
  managerEmail: state.cart && state.cart.managerEmail,
  deliveryAddress: state.cart && state.cart.deliveryAddress,
  deliveryAddressType: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.deliveryAddressType,
  internalDeliveryAddress: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.internalDeliveryAddress,
  responsibleReceiving: state.cart && state.cart.responsibleReceiving,
  deliverySector: state.cart && state.cart.deliverySector,
  cartUser: state.cart && state.cart.user,
  typeOfAccess: state.auth && state.auth.user && state.auth.user.typeOfAccess,
});

const mapDispatchToProps = dispatch => ({
  cartSolicitation: () => dispatch(cartSolicitation()),
  setClientNumber: clientNumber => dispatch(cartSetClientNumber(clientNumber)),
  setMinimumBillingDate: minimumBillingDate => dispatch(cartSetMinimumBillingDate(minimumBillingDate)),
  estimatePurchase: () => dispatch(estimatePurchase()),
  setObservation: text => dispatch(setObservation(text)),
  getFreightGKO: () => dispatch(getFreightGKO()),
  setFeedback: feedbackData => dispatch(savePurchaseFeedback(feedbackData)),
  setPunchOutData: punchOutData => dispatch(updatePunchOutData(punchOutData)),
  setManagerEmail: managerEmail => dispatch(cartSetManagerEmail(managerEmail)),
  setResponsibleReceiving: responsibleReceiving => dispatch(cartSetResponsibleReceiving(responsibleReceiving)),
  setDeliverySector: deliverySector => dispatch(cartSetDeliverySector(deliverySector)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartResume);
